export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    $.fn.ClassyCountdown = function(options) {
        var element = $(this);
        var DaysLeft, HoursLeft, MinutesLeft, SecondsLeft;
        var secondsLeft;
        var isFired = false;
        var settings = {
            end: undefined,
            now: $.now(),
            labels: true,
            labelsOptions: {
                lang: {
                    days: 'Days',
                    hours: 'Hours',
                    minutes: 'Minutes',
                    seconds: 'Seconds',
                },
                style: 'font-size: 0.5em;',
            },
            style: {
                element: '',
                labels: false,
                textResponsive: 0.5,
                days: {
                    gauge: {
                        thickness: 0.15,
                        bgColor: 'rgba(255, 255, 255, 0.2)',
                        fgColor: 'rgba(255, 255, 255, 1)',
                        lineCap: 'round',
                    },
                    textCSS: '',
                },
                hours: {
                    gauge: {
                        thickness: 0.15,
                        bgColor: 'rgba(255, 255, 255, 0.2)',
                        fgColor: 'rgba(255, 255, 255, 1)',
                        lineCap: 'round',
                    },
                    textCSS: '',
                },
                minutes: {
                    gauge: {
                        thickness: 0.15,
                        bgColor: 'rgba(255, 255, 255, 0.2)',
                        fgColor: 'rgba(255, 255, 255, 1)',
                        lineCap: 'round',
                    },
                    textCSS: '',
                },
                seconds: {
                    gauge: {
                        thickness: 0.15,
                        bgColor: 'rgba(255, 255, 255, 0.2)',
                        fgColor: 'rgba(255, 255, 255, 1)',
                        lineCap: 'round',
                    },
                    textCSS: '',
                },
            },
            onEndCallback: function() {
            },
        };
        settings = $.extend(true, settings, options);
        prepare();
        doTick();
        setInterval(doTick, 1000);
        doResponsive();
        
        function prepare() {
            element.append('<div class="ClassyCountdown-wrapper">' +
                    '<div class="ClassyCountdown-days">' +
                        '<input type="text" />' +
                        '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
                    '</div>' +
                    '<div class="ClassyCountdown-hours">' +
                        '<input type="text" />' +
                        '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
                    '</div>' +
                    '<div class="ClassyCountdown-minutes">' +
                        '<input type="text" />' +
                        '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
                    '</div>' +
                    '<div class="ClassyCountdown-seconds">' +
                        '<input type="text" />' +
                        '<span class="ClassyCountdown-value"><div></div><span></span></span>' +
                    '</div>' +
                '</div>');
            element.find('.ClassyCountdown-days input').knob($.extend({
                width: '100%',
                displayInput: false,
                readOnly: true,
                max: 365,
            }, settings.style.days.gauge));
            element.find('.ClassyCountdown-hours input').knob($.extend({
                width: '100%',
                displayInput: false,
                readOnly: true,
                max: 24,
            }, settings.style.hours.gauge));
            element.find('.ClassyCountdown-minutes input').knob($.extend({
                width: '100%',
                displayInput: false,
                readOnly: true,
                max: 60,
            }, settings.style.minutes.gauge));
            element.find('.ClassyCountdown-seconds input').knob($.extend({
                width: '100%',
                displayInput: false,
                readOnly: true,
                max: 60,
            }, settings.style.seconds.gauge));
            element.find('.ClassyCountdown-wrapper > div').attr("style", settings.style.element);
            element.find('.ClassyCountdown-days .ClassyCountdown-value').attr('style', settings.style.days.textCSS);
            element.find('.ClassyCountdown-hours .ClassyCountdown-value').attr('style', settings.style.hours.textCSS);
            element.find('.ClassyCountdown-minutes .ClassyCountdown-value').attr('style', settings.style.minutes.textCSS);
            element.find('.ClassyCountdown-seconds .ClassyCountdown-value').attr('style', settings.style.seconds.textCSS);
            element.find('.ClassyCountdown-value').each(function() {
                $(this).css('margin-top', Math.floor(0 - (parseInt($(this).height()) / 2)) + 'px');
            });
            if (settings.labels) {
                element.find(".ClassyCountdown-days .ClassyCountdown-value > span").html(settings.labelsOptions.lang.days);
                element.find(".ClassyCountdown-hours .ClassyCountdown-value > span").html(settings.labelsOptions.lang.hours);
                element.find(".ClassyCountdown-minutes .ClassyCountdown-value > span").html(settings.labelsOptions.lang.minutes);
                element.find(".ClassyCountdown-seconds .ClassyCountdown-value > span").html(settings.labelsOptions.lang.seconds);
                element.find(".ClassyCountdown-value > span").attr("style", settings.labelsOptions.style);
            }
            secondsLeft = settings.end - settings.now;
            secondsToDHMS();
        }
        
        function secondsToDHMS() {
            DaysLeft = Math.floor(secondsLeft / (3600 * 24));
            HoursLeft = Math.floor((secondsLeft % 86400) / 3600);
            MinutesLeft = Math.floor(((secondsLeft % 86400) % 3600) / 60);
            SecondsLeft = Math.floor((((secondsLeft % 86400) % 3600) % 60) % 60);
        }

        function doTick() {
            secondsLeft--;
            secondsToDHMS();
            if (secondsLeft <= 0) {
                if (!isFired) {
                    isFired = true;
                    settings.onEndCallback();
                }
                DaysLeft = 0;
                HoursLeft = 0;
                MinutesLeft = 0;
                SecondsLeft = 0;
            }
            element.find('.ClassyCountdown-days input').val(DaysLeft).trigger('change');
            element.find('.ClassyCountdown-hours input').val(HoursLeft).trigger('change');
            element.find('.ClassyCountdown-minutes input').val(MinutesLeft).trigger('change');
            element.find('.ClassyCountdown-seconds input').val(SecondsLeft).trigger('change');
            element.find('.ClassyCountdown-days .ClassyCountdown-value > div').html(DaysLeft);
            element.find('.ClassyCountdown-hours .ClassyCountdown-value > div').html(HoursLeft);
            element.find('.ClassyCountdown-minutes .ClassyCountdown-value > div').html(MinutesLeft);
            element.find('.ClassyCountdown-seconds .ClassyCountdown-value > div').html(SecondsLeft);
        }
        
        function doResponsive() {
            element.find('.ClassyCountdown-wrapper > div').each(function() {
                $(this).css('height', $(this).width() + 'px');
            });
            if (settings.style.textResponsive) {
                element.find('.ClassyCountdown-value').css('font-size', Math.floor(element.find('> div').eq(0).width() * settings.style.textResponsive / 10) + 'px');
                element.find('.ClassyCountdown-value').each(function() {
                    $(this).css('margin-top', Math.floor(0 - (parseInt($(this).height()) / 2)) + 'px');
                });
            }
            $(window).trigger('resize');
            $(window).resize($.throttle(50, onResize));
        }

        function onResize() {
            element.find('.ClassyCountdown-wrapper > div').each(function() {
                $(this).css('height', $(this).width() + 'px');
            });
            if (settings.style.textResponsive) {
                element.find('.ClassyCountdown-value').css('font-size', Math.floor(element.find('> div').eq(0).width() * settings.style.textResponsive / 10) + 'px');
            }
            element.find('.ClassyCountdown-value').each(function() {
                $(this).css("margin-top", Math.floor(0 - (parseInt($(this).height()) / 2)) + 'px');
            });
            element.find('.ClassyCountdown-days input').trigger('change');
            element.find('.ClassyCountdown-hours input').trigger('change');
            element.find('.ClassyCountdown-minutes input').trigger('change');
            element.find('.ClassyCountdown-seconds input').trigger('change');
        }
    };

    // JavaScript to be fired on all pages, after page specific JS is fired
    $('body').on('click', '.hamburger' ,function(e){
			$(e.currentTarget).toggleClass('state-active');
			$('#nav').toggleClass('state-active');
		});

    const $popup = $('#popup');

    $(window).on('scroll', function(){
      var s = $(window).scrollTop(),
          d = $(document).height(),
          c = $(window).height();

      var scrollPercent = (s / (d - c)) * 100;

      if(scrollPercent > 60) {
        $popup.addClass('state-active');
        $('#launcher-frame').addClass('state-active');
        $('#drift-widget').addClass('state-active');
      }
    });

    $('form').on('submit', function(){
      window.dataLayer.push({
        'event': 'formSubmitted',
        'formId': $(this).data('formId'),
      });
      return true;
    });

    $('.form-card').on('submit', function(e){
      e.preventDefault();
      var url = $(this).find('[name="link"]').val();
      window.open(url, '_blank');
      return false;
    });

    $('.form-card select').on('change', function(){
      var value = $(this).find("option:selected").val();
      if(value) {
        $('.form-card button').css({"opacity": 1, "pointer-events": "auto"});
      } else {
        $('.form-card button').css({"opacity": 0.5, "pointer-events": "none"});
      }
    });

    $('.countdown-container').each(function(){
      const $this = $(this);
      $this.empty();
      $this.ClassyCountdown({
        now: parseInt($.now() / 1000),
        end: parseInt($this.data('signup')), // end time
      });
    });

    $(window).on('load', function(){
      var heights = $(".js-equalheight").map(function() {
          return $(this).height();
      }).get(),
      maxHeight = Math.max.apply(null, heights);
      $(".js-equalheight").height(maxHeight);
    });

    const $popup_cta = $('#popup_cta');
    $popup_cta.css({'transform':'translateY(-100%)'});

    var throttledListener = throttle(scrollListener, 500);
    window.addEventListener('scroll', throttledListener);
    $('.popup_close').on('click', function(){
      $popup_cta.css({'transform':'translateY(-100%)'});
    });

    function throttle(func, delay) { // allows [func] to run once every [delay] ms
        func = func.bind(func);
        var last = Date.now();
        return function() {
            if (Date.now() - last > delay) {
                func();
                last = Date.now();
            }
        }
    }
    function scrollListener() {
        // console.log('scrolled');
        var threshold = document.body.clientHeight * 0.05;
        if (window.pageYOffset >= threshold) {
          $()
            $popup_cta.css({'transform':'translateY(0)'});
            window.removeEventListener('scroll', throttledListener);
        }
    }

  },
};